<template>
    <script type="application/ld+json">
        {{ jsonLd }}
    </script>
</template>

<script>
    import V from 'voUtils/V.js'
    export default {
    	voVueComponent: 'voffice-facility-json',
    	data() {
    		return {}
    	},
    	props: {
    		street: {
    			type: String,
    			required: true
    		},
    		city: {
    			type: String,
    			required: true
    		},
    		zip: {
    			type: String,
    			required: true
    		},
    		geodata: {
    			type: String,
    			required: true
    		},
    		name: {
    			type: String,
    			default: "K&K Ferienimmobilien GmbH & Co. KG"
    		},
    		url: {
    			type: String,
    			default: "https://www.kuk-ferienwohnungen.de"
    		},
    		telephone: {
    			type: String,
    			default: "+49 3991 7788228"
    		},
    		email: {
    			type: String,
    			default: "info@kuk-ferienimmobilien.de"
    		}
    	},
    	computed: {
    		geo() {
    				if (!this.geodata) return null;

    				const parts = this.geodata.split(",").map(v => parseFloat(v.trim()));

    				return {
    					"@type": "GeoCoordinates",
    					longitude: parts[0],
    					latitude: parts[1]
    				};
    			},

    			jsonLd() {
    				return JSON.stringify({
    					"@context": "https://schema.org",
    					"@type": "LodgingBusiness",
    					"@id": `${this.url}/#lodging`,
    					name: this.name,
    					url: this.url,
    					telephone: this.telephone,
    					email: this.email,
    					description: "Vermietung hochwertiger Ferienwohnungen und Ferienhäuser an der Müritz und Ostsee.",
    					image: ["https://www.kuk-ferienwohnungen.de/images/logo.jpg"],
    					priceRange: "€€",

    					address: {
    						"@type": "PostalAddress",
    						streetAddress: this.street,
    						addressLocality: this.city,
    						postalCode: this.zip,
    						addressCountry: "DE"
    					},

    					geo: {
    						"@type": "GeoCoordinates",
    						geo: this.geo
    					},

    					openingHoursSpecification: [{
    						"@type": "OpeningHoursSpecification",
    						dayOfWeek: [
    							"Monday",
    							"Tuesday",
    							"Wednesday",
    							"Thursday",
    							"Friday",
    							"Saturday",
    							"Sunday"
    						],
    						opens: "08:00",
    						closes: "18:00"
    					}]
    				}, null, 0);
    			}
    	}
    }
</script>